<div class="modal-container" [class.minimized]="minimise">
  <!-- Modal Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{ modalTitle }}</h3>
    <div class="header-actions">
      <i class="fa"
        [class.fa-plus-square-o]="minimise"
        [class.fa-minus-square-o]="!minimise"
        role="button"
        tabindex="0"
        title="Toggle dialog size"
        aria-label="Toggle dialog size"
        style="margin-right: 10px; cursor: pointer;"
        (click)="toggleMinimise()"
        (keydown.enter)="toggleMinimise()"
        (keydown.space)="onSpaceActivate($event, 'minimise')"></i>
      <i class="fa fa-times"
        role="button"
        tabindex="0"
        title="Close"
        aria-label="Close"
        style="cursor: pointer;"
        (click)="cancel()"
        (keydown.enter)="cancel()"
        (keydown.space)="onSpaceActivate($event, 'cancel')"></i>
    </div>
  </div>

  <!-- Body and footer are removed from the DOM while minimised. -->
  @if (!minimise) {
    <div class="modal-body modal-body-wrapper">
      @if (loading) {
        <div class="loading-container">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
      }
      @if (!loading) {
        <div class="modal-body-content">
          @if (errorMessage) {
            <div class="f8964-ele__error">
              {{ errorMessage }}
            </div>
          }
          @if (!errorMessage) {
            <!-- Entity information table -->
            <table class="table table-bordered form-inline enityDetails custom-table">
              <tr>
                @for (item of entityList; track item.key) {
                  <td>
                    <span><strong>{{ item.key }}</strong></span>
                  </td>
                }
              </tr>
              <tr>
                @for (item of entityList; track item.key) {
                  <td>
                    <span>{{ item.value }}</span>
                  </td>
                }
              </tr>
            </table>
            @for (section of formSections; track $index) {
              <!-- Part IV: Line 1 above table, Line 2 in column table -->
              @if (section.mode === 'part4') {
                <div class="part4-section">
                  @for (line of getPartLabelHeaders(section); track line.formLineKey) {
                    <div class="part-label-banner">{{ line.label }}</div>
                  }
                  <!-- Line 1 — above the table (Schedule O form-group pattern) -->
                  @if (getPart4Line1Items(section).length) {
                    <div class="part4-line1-block">
                      @for (line of getPart4Line1Items(section); track line.formLineKey; let lineIdx = $index) {
                        @if (line.kind === 'part4-line1-item') {
                          <div class="row form-group part4-line1-form-group">
                            <label class="col-md-6 control-label">
                              <strong>{{ line.lineNo }}. {{ line.label }}</strong>
                            </label>
                            <div class="col-md-6">
                              @for (field of getDisplayFields(line.fields); track trackByField($index, field)) {
                                <ng-container *ngTemplateOutlet="fieldInput; context: { field: field, idx: lineIdx, lineFields: line.fields }"></ng-container>
                              }
                            </div>
                          </div>
                        }
                      }
                    </div>
                  }
                  <!-- Line 2 description -->
                  @if (getPart4Line2Header(section); as line2Header) {
                    <div class="part4-line2-description">
                      <strong>Line {{ line2Header.lineNo }}.</strong> {{ line2Header.label }}
                    </div>
                  }
                  <!-- Line 2 table — column headers + row-wise data -->
                  <div class="table-container">
                    <table class="table table-bordered f8964-ele-table custom-table part4-line2-table">
                      <thead>
                        <tr>
                          <th style="width: 58px;" class="text-center">Line No</th>
                          @for (colKey of part4ColumnKeys; track colKey) {
                            <th class="text-center">{{ getPart4ColumnHeader(colKey) }}</th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="part4-add-row">
                          <td [attr.colspan]="getColSpan(section.mode)">
                            <i class="fa fa-plus-circle color-green fa-sm pull-left"
                              role="button"
                              tabindex="0"
                              title="Add row"
                              aria-label="Add row"
                              style="cursor: pointer; margin-top: 4px;"
                              (click)="addPart4ShareholderRow()"
                              (keydown.enter)="addPart4ShareholderRow()"
                              (keydown.space)="onSpaceActivate($event, 'addRow')"></i>
                            <span class="part4-add-row-text"
                              role="button"
                              tabindex="0"
                              (click)="addPart4ShareholderRow()"
                              (keydown.enter)="addPart4ShareholderRow()"
                              (keydown.space)="onSpaceActivate($event, 'addRow')">Add Row</span>
                          </td>
                        </tr>
                        @for (line of getVisiblePart4ShareholderTableLines(section); track line.formLineKey; let lineIdx = $index) {
                          <tr class="part4-shareholder-row">
                            <td class="text-center line-no-cell">
                              <i
                                class="fa fa-minus-circle color-red fa-sm part4-delete-row"
                                role="button"
                                tabindex="0"
                                title="Delete row"
                                aria-label="Delete row"
                                style="cursor: pointer;"
                                (click)="deletePart4ShareholderRow(line, $event)"
                                (keydown.enter)="deletePart4ShareholderRow(line, $event)"
                                (keydown.space)="onSpaceActivate($event, 'deleteRow', line)"></i>
                              {{ line.lineNo }}
                            </td>
                            @for (colKey of part4ColumnKeys; track colKey) {
                              <td class="text-center part4-data-cell">
                                @if (getPart4FieldsForColumn(line.fields, colKey); as colFields) {
                                  @for (field of colFields; track trackByField($index, field); let fieldIdx = $index) {
                                    <div
                                      class="part4-cell-field"
                                      [class.part4-cell-field--stacked]="colFields.length > 1">
                                      @if (showPart4FieldSubLabel(colFields, field)) {
                                        <span class="part4-cell-sublabel">{{ field.fieldLabel }}</span>
                                      }
                                      <ng-container *ngTemplateOutlet="fieldInput; context: { field: field, idx: lineIdx * 100 + fieldIdx, lineFields: line.fields }"></ng-container>
                                    </div>
                                  }
                                }
                              </td>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  <!-- Instruction notes for Part IV -->
                  @for (line of section.lines; track line.formLineKey) {
                    @if (line.kind === 'instruction-note') {
                      <div class="instruction-note-block">
                        <i class="fa fa-info-circle"></i> {{ line.label }}
                      </div>
                    }
                  }
                </div>
              } @else {
                @if (section.mode === 'part3') {
                  @for (line of getPartLabelHeaders(section); track line.formLineKey) {
                    <div class="part-label-banner">{{ line.label }}</div>
                  }
                }
                <div class="table-container" [class.table-container--part3]="section.mode === 'part3'">
                  <table class="table table-bordered f8964-ele-table custom-table">
                    <thead>
                      @if (section.mode === 'standard') {
                        <tr>
                          <th style="width: 90px;" class="text-center">Line No</th>
                          <th>Description</th>
                          <th style="width: 280px;" class="text-center">Value</th>
                        </tr>
                      }
                      @if (section.mode === 'part3') {
                        <tr>
                          <th style="width: 58px;" class="text-center">Line No</th>
                          <th>Type of Election</th>
                          <th style="width: 150px;" class="text-center">Identifying number</th>
                          <th style="width: 150px;" class="text-center">Effective date of the election</th>
                          <th style="width: 150px;" class="text-center">Effective date of the revocation</th>
                        </tr>
                      }
                    </thead>
                    <tbody>
                      @for (line of section.lines; track line.formLineKey; let lineIdx = $index) {
                        @if (shouldRenderLineInStandardTable(section, line) && (line.kind === 'form-header' || line.kind === 'section-header')) {
                          <tr
                            class="section-row"
                            [class.part-label-row]="isPartLabelLine(line)"
                            [class.form-header-row]="line.kind === 'form-header'">
                            <td [attr.colspan]="getColSpan(section.mode)">{{ line.label }}</td>
                          </tr>
                        }
                        @if (shouldRenderLineInStandardTable(section, line) && line.kind === 'subsection-header') {
                          <tr
                            class="subsection-row">
                            <td [attr.colspan]="getColSpan(section.mode)">{{ line.label }}</td>
                          </tr>
                        }
                        @if (shouldRenderLineInStandardTable(section, line) && line.kind === 'instruction-note') {
                          <tr
                            class="instruction-note-row">
                            <td [attr.colspan]="getColSpan(section.mode)">
                              <i class="fa fa-info-circle"></i> {{ line.label }}
                            </td>
                          </tr>
                        }
                        @if (shouldRenderLineInStandardTable(section, line) && line.kind === 'data' && section.mode === 'standard') {
                          <tr>
                            <td class="text-center line-no-cell">{{ line.lineNo }}</td>
                            <td class="label-cell">{{ line.label }}</td>
                            <td>
                              @for (field of getDisplayFields(line.fields); track trackByField($index, field)) {
                                <div class="inline-field-block" [class.address-field-block]="isAddressField(field, line.fields)">
                                  @if (shouldShowAddressFieldLabel(field, line.fields)) {
                                    <span class="address-field-label">{{ getAddressFieldLabel(field, line.fields) }}</span>
                                  }
                                  <ng-container *ngTemplateOutlet="fieldInput; context: { field: field, idx: lineIdx, lineFields: line.fields }"></ng-container>
                                </div>
                              }
                            </td>
                          </tr>
                        }
                        @if (shouldRenderLineInStandardTable(section, line) && line.kind === 'multi-col' && section.mode === 'part3') {
                          <tr>
                            <td class="text-center line-no-cell">{{ line.lineNo }}</td>
                            <td class="label-cell election-label-cell">
                              {{ line.label }}
                              @for (field of getPart3LabelFields(line.fields); track trackByField($index, field)) {
                                @if (isCheckboxField(field)) {
                                  <label class="inline-checkbox">
                                    <input type="checkbox"
                                      [checked]="isCheckboxChecked(field)"
                                      [disabled]="isFieldDisabled(field, line.fields)"
                                      (change)="onCheckboxChange(field, $event, line.fields)" />
                                      <span>Election made</span>
                                    </label>
                                  }
                                }
                              </td>
                              @for (colKey of part3ColumnKeys; track colKey) {
                                <td class="text-center">
                                  @for (field of getPart3ColumnFields(line.fields, colKey); track trackByField($index, field)) {
                                    <ng-container *ngTemplateOutlet="fieldInput; context: { field: field, idx: lineIdx, lineFields: line.fields }"></ng-container>
                                  }
                                </td>
                              }
                            </tr>
                          }
                          @if (shouldRenderLineInStandardTable(section, line) && line.kind === 'data' && section.mode === 'part3') {
                            <tr>
                              <td class="text-center line-no-cell">{{ line.lineNo }}</td>
                              <td class="label-cell" [attr.colspan]="4">{{ line.label }}</td>
                            </tr>
                          }
                          @if (shouldRenderLineInStandardTable(section, line) && line.kind === 'multi-col' && section.mode === 'standard') {
                            <tr>
                              <td class="text-center line-no-cell">{{ line.lineNo }}</td>
                              <td class="label-cell">{{ line.label }}</td>
                              <td>
                                @for (field of getDisplayFields(line.fields); track trackByField($index, field)) {
                                  <div class="inline-field-block" [class.address-field-block]="isAddressField(field, line.fields)">
                                    @if (shouldShowAddressFieldLabel(field, line.fields)) {
                                      <span class="address-field-label">{{ getAddressFieldLabel(field, line.fields) }}</span>
                                    }
                                    <ng-container *ngTemplateOutlet="fieldInput; context: { field: field, idx: lineIdx, lineFields: line.fields }"></ng-container>
                                  </div>
                                }
                              </td>
                            </tr>
                          }
                        }
                      </tbody>
                    </table>
                  </div>
                }
                <!-- Standard / Part I–III sections -->
              }
              @if (formSections.length === 0) {
                <div class="no-data-cell">
                  No form data available.
                </div>
              }
            }
          </div>
        }
      </div>
      <div class="modal-footer">
        <button class="save-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
          @if (crudLoading) {
            <span><i class="fa fa-spinner fa-pulse"></i></span>
            }Save
          </button>
          <button class="reset-button"
            type="button"
          (click)="reset()">Reset</button>
          <button class="cancel-button"
            type="button"
          (click)="cancel()">Cancel</button>
        </div>
      }
    </div>

    <ng-template #fieldInput let-field="field" let-idx="idx" let-lineFields="lineFields">
      @if (isPrincipalActivityDescDisplay(field)) {
        <input
          type="text"
          class="form-control input-sm value-input"
          [ngModel]="getPrincipalActivityDescDisplay(field)"
          readonly />
      }

      @if (field.editType === 'readonly' && !isPrincipalActivityDescDisplay(field)) {
        <span class="readonly-value">{{ field.value }}</span>
      }

      @if (field.editType === 'radio') {
        <div class="table-radio-group">
          <label class="table-radio-option">
            <input type="radio"
              [name]="'radio_row_' + idx + '_' + field.objectId"
              [ngModel]="getRadioGroupValue(field, lineFields || [])"
              (ngModelChange)="onRadioGroupChange(field, $event, lineFields || [])"
              value="Y"
              [disabled]="isFieldDisabled(field, lineFields || [])" />
              <span>Yes</span>
            </label>
            <label class="table-radio-option">
              <input type="radio"
                [name]="'radio_row_' + idx + '_' + field.objectId"
                [ngModel]="getRadioGroupValue(field, lineFields || [])"
                (ngModelChange)="onRadioGroupChange(field, $event, lineFields || [])"
                value="N"
                [disabled]="isFieldDisabled(field, lineFields || [])" />
                <span>No</span>
              </label>
            </div>
          }

          @if (field.editType === 'checkbox') {
            <label class="inline-checkbox">
              <input type="checkbox"
                [checked]="isCheckboxChecked(field)"
                [disabled]="isFieldDisabled(field, lineFields || [])"
                (change)="onCheckboxChange(field, $event)" />
              </label>
            }

            @if (isPrincipalActivityCodeDropdown(field)) {
              <select
                class="form-control input-sm value-input"
                [ngModel]="getPrincipalActivityCodeModel(field) || ''"
                [disabled]="isFieldDisabled(field, lineFields || [])"
                (ngModelChange)="onPrincipalActivityCodeFieldChange(field, $event)">
                <option value="">Select Principal Business Activity</option>
                @for (p of principalBusinessActivityList; track p.ACTIVITY_CODE) {
                  <option [value]="p.ACTIVITY_CODE">{{ p.ACTIVITY_CODE }} - {{ p.ACTIVITY_DESC }}</option>
                }
              </select>
            }

            @if (isFunctionalCurrencyDropdown(field)) {
              <select
                class="form-control input-sm value-input"
                [ngModel]="getFunctionalCurrencyModel(field) || ''"
                [disabled]="isFieldDisabled(field, lineFields || [])"
                (ngModelChange)="onFunctionalCurrencyFieldChange(field, $event)">
                <option value="">Select Functional Currency</option>
                @for (cur of currencies; track cur.CURR_CODE) {
                  <option [value]="cur.CURR_CODE">{{ cur.CURR_CODE }} - {{ cur.CURR_DESC }}</option>
                }
              </select>
            }

            @if (field.editType === 'dropdown' && isUsStateDropdown(field, lineFields || [])) {
              <select
                class="form-control input-sm value-input"
                [ngModel]="getDropdownModelValue(field) || ''"
                [disabled]="isFieldDisabled(field, lineFields || [])"
                (ngModelChange)="onDropdownChange(field, $event, lineFields || [])">
                <option value="">Select State</option>
                @for (s of states; track s.CODE) {
                  <option [value]="s.CODE">{{ s.CODE }} - {{ s.NAME }}</option>
                }
              </select>
            }

            @if (isUsStateTextInput(field, lineFields || [])) {
              <input
                type="text"
                class="form-control input-sm value-input"
                [name]="field.attribName"
                [attr.aria-label]="getAddressFieldLabel(field, lineFields || [])"
                [ngModel]="field.value"
                [disabled]="isFieldDisabled(field, lineFields || [])"
                (ngModelChange)="field.value = $event; onFieldChange(field)" />
            }

            @if (isForeignStateField(field)) {
              <input
                type="text"
                class="form-control input-sm value-input"
                [name]="field.attribName"
                [ngModel]="field.value"
                [disabled]="isFieldDisabled(field, lineFields || [])"
                (ngModelChange)="field.value = $event; onFieldChange(field)" />
            }

            @if (field.editType === 'dropdown' && !isPrincipalActivityCodeDropdown(field) && !isFunctionalCurrencyDropdown(field) && !isUsStateField(field)) {
              <select
                class="form-control input-sm value-input"
                [ngModel]="getDropdownModelValue(field) || ''"
                [disabled]="isFieldDisabled(field, lineFields || [])"
                (ngModelChange)="onDropdownChange(field, $event, lineFields || [])">
                <option value="">{{ getDropdownPlaceholder(field) }}</option>
                @for (opt of field.dropdownOptions; track opt.code) {
                  <option [value]="opt.code">{{ opt.desc }}</option>
                }
              </select>
            }

            @if (field.editType === 'date') {
              <input
                type="date"
                class="form-control input-sm value-input date-picker-only"
                [ngModel]="getDateFieldModel(field)"
                [disabled]="isFieldDisabled(field, lineFields || [])"
                (keydown)="onDateFieldKeyDown($event)"
                (paste)="onDateFieldPaste($event)"
                (drop)="onDateFieldDrop($event)"
                (beforeinput)="onDateFieldBeforeInput($event)"
                (ngModelChange)="onDateFieldChange(field, $event)" />
            }

            @if (field.editType === 'number' && !isFunctionalCurrencyDropdown(field)) {
              <input
                type="text"
                class="form-control input-sm value-input text-right"
                onlyIntegersWithLength
                [ngModel]="field.value"
                [disabled]="isFieldDisabled(field, lineFields || [])"
                (ngModelChange)="field.value = $event; onFieldChange(field)" />
            }

            @if (field.editType === 'text' && !isForeignStateField(field) && !isUsStateTextInput(field, lineFields || []) && !isPrincipalActivityCodeDropdown(field) && !isPrincipalActivityDescDisplay(field) && !isFunctionalCurrencyDropdown(field)) {
              <input
                type="text"
                class="form-control input-sm value-input"
                [class.text-right]="isRightAlignedField(field)"
                [name]="field.attribName"
                [ngModel]="field.value"
                [disabled]="isFieldDisabled(field, lineFields || [])"
                (ngModelChange)="field.value = $event; onFieldChange(field)" />
            }
          </ng-template>
